const e = [
  {
    anonymous: !1,
    inputs: [],
    name: "",
    outputs: null,
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_oldAdmin",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "",
        name: "_newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_oldAdmin",
        type: "address"
      }
    ],
    name: "AdminRemoved",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "",
        name: "_spender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "Approval",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_minter",
        type: "address"
      }
    ],
    name: "MinterAdded",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_minter",
        type: "address"
      }
    ],
    name: "MinterRemoved",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "Paused",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_spender",
        type: "address"
      }
    ],
    name: "SpenderUnwhitelisted",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_spender",
        type: "address"
      }
    ],
    name: "SpenderWhitelisted",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "",
        name: "_from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "",
        name: "_to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "Unpaused",
    outputs: null,
    payable: !1,
    stateMutability: "",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_addedMinters",
        type: "address[]"
      }
    ],
    name: "addMinters",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [],
    name: "admin",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "address"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_owner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_spender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_success",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_success",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_from",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "burnFrom",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_success",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_newAdmin",
        type: "address"
      }
    ],
    name: "changeAdmin",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "uint8"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "initialize",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_addr",
        type: "address"
      }
    ],
    name: "isMinter",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_success",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "address"
      }
    ],
    name: "minter",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "uint256"
      }
    ],
    name: "minters",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "address"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "pause",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [],
    name: "paused",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "removeAdmin",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_removedMinters",
        type: "address[]"
      }
    ],
    name: "removeMinters",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_success",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_from",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "",
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_success",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [],
    name: "unpause",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_spender",
        type: "address"
      }
    ],
    name: "unwhitelist",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "_spender",
        type: "address"
      }
    ],
    name: "whitelist",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: !1,
    constant: !0,
    inputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "address"
      }
    ],
    name: "whitelisted",
    outputs: [
      {
        indexed: !1,
        internalType: "",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=ronin-usdc.json.js.map
